import { Controller, useFormContext } from "react-hook-form";

const FormInput = (props) => {
  const { control } = useFormContext();
  const { name, render } = props;
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => render(field, fieldState)}
    />
  );
};

export { FormInput };
